/**
 * Application configuration constants.
 * Centralized place for all hardcoded values used across the app.
 */

// API Configuration - required environment variable
const apiBaseUrl = process.env.API_BASE_URL;
if (!apiBaseUrl) {
  throw new Error('Missing required environment variable: API_BASE_URL');
}
export const API_BASE_URL = apiBaseUrl;

// Jira Configuration - required environment variable
const jiraBaseUrl = process.env.JIRA_BASE_URL;
if (!jiraBaseUrl) {
  throw new Error('Missing required environment variable: JIRA_BASE_URL');
}
export const JIRA_BASE_URL = jiraBaseUrl;

// Time Tracking
export const DAILY_GOAL_SECONDS = 8 * 60 * 60; // 8 hours in seconds
export const DAILY_GOAL_HOURS = 8;

// Locale Configuration
export const DEFAULT_LOCALE = 'pl-PL';

// Pagination Defaults
export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = [10, 20, 50] as const;

// Feature Flags
export const HAS_API = false;

// Timer Storage
export const ACTIVE_TIMER_STORAGE_KEY = 'timetracker_active_timer';
